@if (hasError === true) {
  <app-advisor-errorpage></app-advisor-errorpage>
}

@if (hasError === null) {
  <div class="loading"></div>
}

@if (hasError === false) {
  <div>
    <section class="result">
      <div class="grid-x grid-margin-x headline-wrapper ng-star-inserted">
        @if (forceDialog || showDownload) {
          <div class="cell small-12 large-12">
            <dialog-hint clickTarget="next-steps" textkey="bekocheck.ergebnis.callout"
                         [closable]="true"></dialog-hint>
          </div>
        }
        <div class="cell small-12 large-offset-1 large-10 text-center">
          <h1 [innerHTML]="'bekocheck.ergebnis.headline' | translate"></h1>
        </div>
        <div class="cell small-12 large-offset-1 large-10">
          <p [innerHTML]="'bekocheck.ergebnis.teaser' | translate"></p>
          <p class="subheadline" [innerHTML]="'bekocheck.ergebnis.subheadline' | translate"></p>
        </div>
      </div>
    </section>

    <section>
      <div class="grid-x grid-padding-x">
        <div class="cell small-12 medium-10 medium-offset-1">
          <app-betriebskostenspiegel (stageSet)="setStage($event)"
                                     textKeyPrefix="bekocheck.ergebnis.condition"
                                     [isApartementBuilding]="result['isApartementBuilding']"
                                     [value]="result['sumUserAverage']"
                                     [min]="result['kosten_min']"
                                     [max]="result['kosten_max']">
          </app-betriebskostenspiegel>
        </div>
      </div>
    </section>

    <section>
      <app-kosten-sparpotenzial [internalPortal]="internalPortal"
                                [textPlaceholder]="placeholder"
                                textkeyPrefix="bekocheck.ergebnis.kosten"
                                imagePath="/bkc/bkc-kosten.svg"
                                teaser="bekocheck.ergebnis.cost_items.teaser"
                                [savingsEuroYear]="result.mehrkostenGebaeude > 0 ? result.mehrkostenGebaeude : 0"
                                [stage]="stage"
                                [showTimespan]="true">
      </app-kosten-sparpotenzial>
      <app-bkc-tipps [tipps]="result.costItems" [tippCountDefault]="6"
                     [headline]="'bekocheck.ergebnis.cost_items.headline'"></app-bkc-tipps>
    </section>

    @if (advisorUrls) {
      <section>
        @if (advisorUrls.hec && anfrage.userInput.heizungstyp === 'zentral') {
          <app-advisor-teaser [url]="advisorUrls.hec" [mailUrl]="advisorUrls.hec"
                              textPrefix="bekocheck.ergebnis.teaser.hec"
                              image="/bkc/hec-teaser.svg"></app-advisor-teaser>
        }
        @if (advisorUrls.wwc) {
          <app-advisor-teaser [url]="advisorUrls.wwc" [mailUrl]="advisorUrls.wwc"
                              textPrefix="bekocheck.ergebnis.teaser.wwc" image="/bkc/wwc-teaser.svg"
                              [changeColumnOrder]="true"></app-advisor-teaser>
        }
      </section>
    }

    @if (internalPortal) {
      <section>
        <h2 [innerHtml]="'bekocheck.ergebnis.betriebskosten.headline' | translate" class="text-center"></h2>
        <app-tipps-slider [tipps]="tipps.betriebskosten" textPrefix="bekocheck.ergebnis.tipp"
                          [hideButton]="!internalPortal"></app-tipps-slider>
      </section>
    }

    <section>
      <app-portal-teaser></app-portal-teaser>
    </section>

    @if (forceDialog || showDownload) {
      <section id="next-steps">
        <div class="grid-x grid-margin-x">
          <div class="cell small-12 medium-8">
            <div class="nextsteps-wrapper" [class.internal]="internalPortal">
              <h2 [innerHTML]="textkeyPrefix + '.ergebnis.nextsteps.headline' | translate"></h2>
              <p [innerHTML]="textkeyPrefix + '.ergebnis.nextsteps.teaser' | translate"></p>
            </div>
          </div>
        </div>
      </section>
    }

    @if (forceDialog) {
      <section>
        <app-dialogform textkeyPrefix="bekocheck.newsletter" advisorImagePath="/bkc/pdf-lead.svg"
                        [registrationData]="dialogData" (onDialogRegister)="dialogRegistered($event)" [downloadUrl]="anfrage?.result?.report"></app-dialogform>
      </section>
    }

    @if (anfrage?.result?.report && showDownload) {
      <section>
        <app-download [url]="anfrage.result.report" textkeyPrefix="bekocheck.datenblatt."></app-download>
      </section>
    }

    @if (internalPortal === true) {
      <section>
        <app-donate textkeyPrefix="bekocheck"></app-donate>
      </section>
    }
  </div>
}
@if (hasError === false) {
  <app-step-buttons
    previousLink="../../eingabe/weitere-kostenpositionen/9"
    mediumWidthRight="8"
    largeWidthRight="5"
    mediumOffset="auto"
    leftAlignSize=""
    largeOffset="auto"
    previousText="step.button.previous"
    [nextLink]="this.showResetButton? '../../eingabe/start' : null"
    nextText="step.button.newrequest"
    [nextSubmit]="false"
    (onNextClick)="resetRequest()"
  ></app-step-buttons>
}
